// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"_3I7JSenM","content":"_2NDt8ny2","logo":"_C7AhFcc"};


//////////////////
// WEBPACK FOOTER
// ./app/account/components/windowed/windowed.styles.scss
// module id = 361
// module chunks = 0